const SUCCESS = 200
const SYS_ERROR = '999999'
const TIME_OUT = '401001'
const API_FAILED = '000009'
const VALIDATE_ERROR = '200001'
const TOAST_DURATION = 3000

export default {
    SUCCESS,
    SYS_ERROR,
    TIME_OUT,
    API_FAILED,
    VALIDATE_ERROR,
    TOAST_DURATION
}



// WEBPACK FOOTER //
// ./src/common/js/util/global_code.js